import React from 'react'
import PropTypes from 'prop-types'

import strings from 'utils/strings'
import { keepAwakeLabel } from 'i18n/displayConstants/featureOutputs'
import { Switch } from 'components/patterns/Inputs'

import outputSchema from 'schemas/validation/feature/outputSchema'
import { schemaProp } from 'schemas/validation'

const rule = schemaProp(outputSchema)

const OutputKeepAwakeSwitch = ({ isAwake, onChange }) => (
  <Switch
    className="form-field"
    value={isAwake}
    label={strings.keep_awake}
    name={strings.keep_awake}
    rules={rule('isAwake')}
    tooltip={strings.keep_awake_tooltip}
    switchLabels={keepAwakeLabel}
    onChange={onChange}
    wrapperDataTestId="output-keep-awake-switch"
  />
)

OutputKeepAwakeSwitch.propTypes = {
  isAwake: PropTypes.bool,
  onChange: PropTypes.func,
}

export default OutputKeepAwakeSwitch
